import type { NoddiRadioOption } from 'noddi-ui-web';

export type DiscountKind = 'amount' | 'percentage';

export const DISCOUNT_KIND = {
  amount: 'amount',
  percentage: 'percentage'
} as const satisfies Record<DiscountKind, DiscountKind>;

export const DISCOUNT_KIND_RADIO_OPTIONS: NoddiRadioOption<DiscountKind>[] = [
  { value: DISCOUNT_KIND.amount, label: 'Fixed amount' },
  { value: DISCOUNT_KIND.percentage, label: 'Percentage' }
];
